import React from "react";
import {
    Heading,
    ListItem,
    List,
    Text
} from "spectacle";
import Button from '../components/Button';

const MissedOpportunity = () =>
    <div>
        <Heading size={6} textColor="secondary" caps bold>
            THE MISSED OPPORTUNITY
        </Heading>
        <Text textSize={30} textColor="primary">
            Many unanswered questions
        </Text>
        <List ordered textColor="secondary" style={{ paddingLeft: '25px', listStylePosition: 'outside' }}>
            <ListItem textSize={25}>Which presentation is the best with the high probability making the prospect a customer?</ListItem>
            <ListItem textSize={25}>What is the prospect most interested in</ListItem>
            <ListItem textSize={25}>Did they share this with someone else in their org?  If so, who?</ListItem>
            <ListItem textSize={25}>Are they even interested/Is this worth my time</ListItem>
        </List>
    </div>

export default MissedOpportunity;


// WEBPACK FOOTER //
// ./src/slides/MissedOpportunity.js